import { useT } from "@transifex/react";
import React from "react";
import StyledButtonWithIcon from "../../../../../../basic/styledButtonWithIcon/StyledButtonWithIcon";

import { AddVocabularyButtonWrapper } from "./StyledComponents";

export interface AddVocabularyButtonProps {
    onClickAddVocabularyButton: () => void;
}

const AddVocabularyButton: React.FC<AddVocabularyButtonProps> = (props) => {
    const t = useT();
    const t_addWords = t("Add words", { _tags: "CreateTest,ExerciseDetails" });

    return (
        <AddVocabularyButtonWrapper>
            <StyledButtonWithIcon
                data-testid="button-add-vocabulary"
                buttonStyle={"BLANK"}
                icon={"add"}
                iconPosition={"LEFT"}
                onClick={props.onClickAddVocabularyButton}
            >
                {t_addWords}
            </StyledButtonWithIcon>
        </AddVocabularyButtonWrapper>
    );
};

export default AddVocabularyButton;
